import styled from 'styled-components';

export const Container = styled.div`
  width:100%;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
